(function ($, window, document, undefined) {

Navigation = ( function() {

    function Constructor() {

        this.start = function () {
        
            let instance = this;

            $( '.nav-drawer .menu-halo-header-container > ul' ).append( $( '.nav-drawer .menu-primary-container > ul > li' ) );

            $( '.menu-toggle, .nav-drawer .close' ).click( function () {
                $( '.nav-bg' ).toggleClass( 'open' );
                $( '.nav-drawer' ).toggleClass( 'open' );
            } );

            $( '.nav-bg, .nav-bg a' ).click( function () {
                $( '.nav-bg' ).removeClass( 'open' );
                $( '.nav-drawer' ).removeClass( 'open' );
            } );

            $( '.nav-drawer li.menu-item-has-children > a' ).click( function ( e ) {
                e.preventDefault();
                e.stopPropagation();

                let href = $( this ).attr('href');

                if ( href !== undefined ) {
                    window.location.href = href;
                } else {
                    instance.nextSubmenu($(this));
                }

                return false;
            } );

            $( '.nav-drawer li.menu-item-has-children' ).click( function (e) {
                e.stopPropagation();

                instance.nextSubmenu($(this).find('> a'));
            } );

            $( '.nav-drawer .back' ).click( function (e) {
                e.preventDefault();
                $( '.nav-drawer .back' ).removeClass( 'slided' );
                $( '.nav-drawer .menu-halo-header-container' ).css( 'height', 'auto' ).removeClass( 'slided' ).removeClass( 'detent2' );
                $( '.nav-drawer ul' ).removeClass( 'activated' );
                return false;
            } );

            $( '.nav-woo-holder .search .icon').click(function (e) {
                e.preventDefault();
                $( '.header-top' ).toggleClass( 'reveal' );
                $( '.header-top .search-form input').focus();
                return false;
            });
            $( '.header-top .search-form input').on('input', function() {
                if ( $( this ).val()=='' ) {
                    $( '.header-top' ).removeClass( 'searchable' );
                } else {
                    $( '.header-top' ).addClass( 'searchable' );
                }
            });
            $( '.header-top .search-form button').click(function (e) {
                if ( $( this ).prev().val()=='' ) {
                    e.preventDefault();
                    $( '.header-top' ).toggleClass( 'reveal' );
                    return false;
                }
            });

        };

        this.nextSubmenu = function(link) {
            $( '.nav-drawer .back' ).addClass( 'slided' );
            $( '.nav-drawer .menu-halo-header-container' ).css( 'height', link.next().height() ).addClass( 'slided' );
            var prevul = link.closest( 'ul' );
            if ( prevul && prevul.hasClass( 'sub-menu' ) ) {
                $( '.nav-drawer .menu-halo-header-container' ).addClass( 'detent2' );
            }
            $( '.nav-drawer ul' ).removeClass( 'activated' );
            link.next().addClass( 'activated' );
            if ( prevul ) {
                link.closest( 'ul' ).addClass( 'activated' );
            }
            return false;
        }

    }

    return new Constructor();

}() );

})(jQuery, window, document);
